import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Avatar from 'components/common/Avatar';
import Flex from 'components/common/Flex';
import IconButton from 'components/common/IconButton';
import { agentFeedbackInertUpdate, getAgentFeedbacks, getTicketMasterCon, getUpdatesByTicket, ticketReject, getTicketRejectStatus } from 'functions/ticket';
import { getUsers } from 'functions/user';

//import { messages } from 'data/support-desk/ticketsPreviewData';

import React, { useEffect } from 'react';
import {
  Button,
  Card,
  Dropdown,
  Modal
} from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useState } from 'react';
import Reply from 'components/app/support-desk/ticket/ssp/compose/Reply';
import { acceptTicket, addTicketDetail, checkForNewReply, deleteConversationReply, getTicketDetailSharedUser, getTicketMasterDetails, getTicketMasterDetailsGreaterThanTicketDetailId, isFeedbackSubmitted, isFeedbackSubmittedd, isTicketAccepted, isTicketClosed, markConversationAsSeen, openTicket } from 'functions/ticket';
import moment from 'moment/moment';

import Attachments from '../Attachments';
import CustomerReview from 'components/CustomerReview';
import avatarImg from 'assets/img/team/avatar.png';
import TicketsPreviewHeader from './TicketsPreviewHeader';
import TicketManualTimeEntry from 'components/TicketManualTimeEntry';
import TicketWorkTimer from 'components/TicketWorkTimer';
import { timeElapsed } from 'components/shared/shared';
import DeleteConfirm from 'components/dialogBoxes/DeleteConfirm';
import WaitingBox from 'components/dialogBoxes/WaitingBox';
import { toastMessageBox } from 'components/ToastifyMessage';

import { socket } from '../../../../web_socket/socket'
import { playNotificationAgentConversation, playNotificationSound, playNotificationSoundConversation } from 'helpers/sounds';
import { getUserbyUserId } from 'functions/user';

const API = process.env.REACT_APP_API_PATH;


// const FullscreenModal = ({ show, handleClose, imageUrl }) => {
//   return (
//     <div
//     style={{
//       display: 'flex',
//       flexDirection: 'column',
//       position: 'fixed',
//       top: 0,
//       left: 0,
//       width: '100vw',
//       height: '100vh',
//       backgroundColor: 'rgba(0, 0, 0, 0.8)',
//       zIndex: 9999,
//       color: 'white',
//       textAlign: 'center',
//       paddingTop: '0vh',
//       fontSize: '24px'
//     }}
//   >
//     <span
//       style={{
//         position: 'absolute',
//         top: '20px',
//         right: '35px',
//         cursor: 'pointer',
//         color: 'white',
//         fontSize: '24px',
//       }}
//       onClick={handleClose}
//     >
//       &#10006;
//     </span>
//         <img src={imageUrl} alt="Fullscreen" className="img-fluid"
//        style={{ objectFit:'cover',margin:'60px',width:'80%' }} />
//   </div>
//   );
// };


const MessagePublic = ({ message, index, onRemoveDeleteReply }) => {
  const { ticketDetailId } = message;

  const [fullscreenImage, setFullscreenImage] = useState(null);
  const [isConvMessageDeleting, setIsConvMessageDeleting] = useState(false);
  const userDataRaw = localStorage.getItem('userData');
  const _userData = userDataRaw ? JSON.parse(userDataRaw) : {};

  const openFullscreen = imageUrl => {
    setFullscreenImage(imageUrl);
  };

  const closeFullscreen = () => {
    setFullscreenImage(null);
  };

  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  const cancelDelteConvRepHandler = async () => {
    setShowDeleteConfirm(null);
    console.log('Cancelled!');
  };

  const confirmDelteConvRepHandler = async () => {
    try {
      setIsConvMessageDeleting(true);
      setShowDeleteConfirm(null);
      const token = localStorage.getItem('token');
      const res = await deleteConversationReply(
        showDeleteConfirm,
        '5:30',
        token
      );
      console.log('confirmCloseHandler', res);
      const { outputMessage, responseStatus, TicketDetailId_o } =
        res.data.output;

      if (responseStatus === 'failed') {
        toastMessageBox('Exception', outputMessage, 'danger');
        setIsConvMessageDeleting(false);
        return;
      }

      await onRemoveDeleteReply(TicketDetailId_o);
      setIsConvMessageDeleting(false);
      // messageBox('Successful', outputMessage, 'success');
    } catch (err) {
      setIsConvMessageDeleting(false);
      console.log('Error', err);
    }
  };

  // useEffect(() => {
  //   loadPrivateMessgaeSharedUser();
  // }, []);

  // const [sharedUsers, setSharedUsers] = useState(null);

  // const loadPrivateMessgaeSharedUser = async () => {
  //   const sharduser = await getTicketDetailSharedUser(message.ticketDetailId);
  //   setSharedUsers(sharduser);
  // };

  const delteConvReplyHandler = async value => {
    console.log('deletecons handler', value);
    setShowDeleteConfirm(value);
  };

  return (
    <div
      className="m-2 p-2"
      style={{
        backgroundColor: '#f9fafd',
        borderRadius: 10
      }}
    >
      {isConvMessageDeleting && (
        <WaitingBox message="The message is being deleted..." />
      )}
      {showDeleteConfirm && (
        <DeleteConfirm
          title="Confirm Deletion"
          message="Do you really want to delete this reply?"
          onConfirm={confirmDelteConvRepHandler}
          onCancel={cancelDelteConvRepHandler}
        />
      )}
      {/* mail header */}
      <div className="d-lg-flex justify-content-between">

        <div className="d-md-flex d-xl-inline-block d-xxl-flex align-items-center justify-content-between mb-x1">
          <Flex alignItems="center" className="gap-2">
            <Link to="/support-desk/contact-details">
              <Avatar src={message.img} size="2xl" />
            </Link>
            <p className="mb-0">
              <Link
                to="/support-desk/contact-details"
                className="fw-semi-bold mb-0 text-800"
              >
                {message.sender}
              </Link>
              <span className="fs--2 text-800 fw-normal mx-2">
                {message.type}
              </span>
              <a
                className="mb-0 fs--1 d-block text-500"
                href={`mailto:${message.email}`}
              >
                {message.email}
              </a>
            </p>
          </Flex>
          <p className="mb-0 fs--2 fs-sm--1 fw-semi-bold mt-2 mt-md-0 mt-xl-2 mt-xxl-0 ms-5">
            {message.createdDate}
            <span className="mx-1">|</span>
            <span className="fst-italic">{message.time_elapsed}</span>
            <FontAwesomeIcon icon="star" className="ms-2 text-warning" />
          </p>
        </div>

        <div id="orders-actions">
          {message.userId === _userData.userId && <Dropdown align="end" className="btn-reveal-trigger d-inline-block">
            <Dropdown.Toggle split variant="falcon-default" size="sm">
              <FontAwesomeIcon icon="ellipsis-h" className="fs--2" />
            </Dropdown.Toggle>

            <Dropdown.Menu className="border py-0">
              <div className="py-2">
                <Dropdown.Item
                  className="text-danger"
                  onClick={() => delteConvReplyHandler(message.ticketDetailId)}
                >
                  Delete
                </Dropdown.Item>
              </div>
            </Dropdown.Menu>
          </Dropdown>}
        </div>
      </div>

      <h6 className="mb-3 fw-semi-bold text-1000">{message.subject}</h6>

      <div style={{ maxWidth: '100%', overflow: 'hidden' }}>
        <p dangerouslySetInnerHTML={{ __html: message.message }} />


      </div>
      {/* {JSON.stringify(message.isAttachmentExists)} */}
      {message.isAttachmentExists && <Attachments ticketDetailId={ticketDetailId} />}

    </div>
  );
};

const MessagePrivate = ({ message, index, onRemoveDeleteReply }) => {
  const { ticketDetailId } = message;
  const [isConvMessageDeleting, setIsConvMessageDeleting] = useState(false);

  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const userDataRaw = localStorage.getItem('userData');
  const _userData = userDataRaw ? JSON.parse(userDataRaw) : {};


  const cancelDelteConvRepHandler = async () => {
    setShowDeleteConfirm(null);
    console.log('Cancelled!');
  };

  const confirmDelteConvRepHandler = async () => {
    try {
      setIsConvMessageDeleting(true);
      setShowDeleteConfirm(null);
      const token = localStorage.getItem('token');
      const res = await deleteConversationReply(
        showDeleteConfirm,
        '5:30',
        token
      );
      console.log('confirmCloseHandler', res);
      const { outputMessage, responseStatus, TicketDetailId_o } =
        res.data.output;

      if (responseStatus === 'failed') {
        toastMessageBox('Exception', outputMessage, 'danger');
        setIsConvMessageDeleting(false);
        return;
      }

      await onRemoveDeleteReply(TicketDetailId_o);
      setIsConvMessageDeleting(false);

      // messageBox('Successful', outputMessage, 'success');
    } catch (err) {
      setIsConvMessageDeleting(false);
      console.log('Error', err);
    }
  };

  useEffect(() => {
    loadPrivateMessgaeSharedUser();
  }, []);

  const [sharedUsers, setSharedUsers] = useState(null);

  const loadPrivateMessgaeSharedUser = async () => {

    const sharduser = await getTicketDetailSharedUser(message.ticketDetailId);
    console.log('sharduser', sharduser);
    setSharedUsers(sharduser);

  }

  const delteConvReplyHandler = async value => {
    console.log('deletecons handler', value);
    setShowDeleteConfirm(value);
  };

  return (
    <>
      {sharedUsers ?
        <div
          className="m-2 p-2"
          style={{
            backgroundColor: '#c2e6ff',
            borderRadius: 10

          }}
        >
          <div
            style={{
              justifyContent: 'center',
            }}
          >
            <div style={{ alignItems: 'flex-start' }}>
              <p style={{ color: '#0092f7', fontWeight: 'bold' }}>Private message</p>
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <p
                style={{
                  marginRight: '10px',
                  textAlign: 'center',
                  paddingTop: '13px',
                  marginRight: '10px',
                  fontWeight: 'bold'
                }}
              >
                shared with:
              </p>
              <div style={{ display: 'flex' }} className="gap-2">
                {sharedUsers &&
                  sharedUsers.map(u => (
                    <div style={{ display: 'flex' }}>
                      <div
                        style={{
                          padding: '3px',
                          paddingRight: '10px',
                          backgroundColor: '#dee2e6',
                          borderRadius: 40,
                          display: 'flex',
                          alignItems: 'center'
                        }}
                      >
                        <Avatar
                          size="m"
                          src={`${API}/file/image/${u.ProfilePic}`}
                        />
                        <div className="flex-1 ms-1">
                          <p className="mb-0" style={{ fontSize: '13px' }}>
                            {u.UserName}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>


          <div className="mb-2 p-2">
            {isConvMessageDeleting && (
              <WaitingBox message="The message is being deleted..." />
            )}
            {showDeleteConfirm && (
              <DeleteConfirm
                title="Confirm Deletion"
                message="Do you really want to delete this reply?"
                onConfirm={confirmDelteConvRepHandler}
                onCancel={cancelDelteConvRepHandler}
              />
            )}
            {/* mail header */}
            <div className="d-lg-flex justify-content-between">
              <div className="d-md-flex d-xl-inline-block d-xxl-flex align-items-center justify-content-between mb-x1">
                <Flex alignItems="center" className="gap-2">
                  <Link to="/support-desk/contact-details">
                    <Avatar src={message.img} size="2xl" />
                  </Link>
                  <p className="mb-0">
                    <Link
                      to="/support-desk/contact-details"
                      className="fw-semi-bold mb-0 text-800"
                    >
                      {message.sender}
                    </Link>
                    <span className="fs--2 text-800 fw-normal mx-2">
                      {message.type}
                    </span>
                    <a
                      className="mb-0 fs--1 d-block text-500"
                      href={`mailto:${message.email}`}
                    >
                      {message.email}
                    </a>
                  </p>
                </Flex>
                <p className="mb-0 fs--2 fs-sm--1 fw-semi-bold mt-2 mt-md-0 mt-xl-2 mt-xxl-0 ms-5">
                  {message.createdDate}
                  <span className="mx-1">|</span>
                  <span className="fst-italic">{message.time_elapsed}</span>
                  <FontAwesomeIcon icon="star" className="ms-2 text-warning" />
                </p>
              </div>

              <div id="orders-actions">
                {message.userId === _userData.userId && <Dropdown align="end" className="btn-reveal-trigger d-inline-block">
                  <Dropdown.Toggle split variant="falcon-default" size="sm">
                    <FontAwesomeIcon icon="ellipsis-h" className="fs--2" />
                  </Dropdown.Toggle>

                  <Dropdown.Menu className="border py-0">
                    <div className="py-2">
                      <Dropdown.Item
                        className="text-danger"
                        onClick={() => delteConvReplyHandler(message.ticketDetailId)}
                      >
                        Delete
                      </Dropdown.Item>
                    </div>
                  </Dropdown.Menu>
                </Dropdown>}
              </div>
            </div>
            <h6 className="mb-3 fw-semi-bold text-1000">{message.subject}</h6>

            {/* <p dangerouslySetInnerHTML={{ __html: message.message }} /> */}
            <div style={{ maxWidth: '100%', overflow: 'hidden' }}>
              <p dangerouslySetInnerHTML={{ __html: message.message }} />

              {/* <div>
            <div>
              <input type="checkbox" id="modal-trigger" />

              <div id="fullscreen-modal">
                <label for="modal-trigger" id="close-button">
                  &#10006;
                </label>
                <img
                  src="http://localhost:8000/api/file/image/002818"
                  alt="Fullscreen Image"
                />
              </div>
            </div>
          </div> */}
            </div>

            <Attachments ticketDetailId={ticketDetailId} />

          </div>
        </div> : <p style={{ paddingLeft: '21px', paddingTop: '10px' }}>loading...</p>}
    </>
  );
};

const DeletedMessage = ({ message }) => {
  const { sender, senderImage } = message;

  return (

    <div style={{ margin: '10px', padding: '10px', borderRadius: '10px', backgroundColor: '#f9fafd' }} className="d-md-flex d-xl-inline-block d-xxl-flex align-items-center justify-content-between mb-x1">
      <Flex alignItems="center" className="gap-2">
        <Link to="/support-desk/contact-details">
          <Avatar src={message.img} size="2xl" />
        </Link>
        <p className="mb-0">
          <Link
            to="/support-desk/contact-details"
            className="fw-semi-bold mb-0 text-800"
          >
            {message.sender}
          </Link>

        </p>
      </Flex>

      <div
        className="m-2 p-2"
        style={{
          borderRadius: 10,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center', // Center horizontally
          textAlign: 'center', // Center text horizontally
        }}
      >

        <div >
          <p style={{ fontStyle: 'italic', fontSize: '12px' }} className="fw-semi-bold mb-0 text-500">
            Message Deleted <FontAwesomeIcon icon="trash" style={{ color: '#dc3545', marginLeft: '2px', fontSize: '20px' }} />
          </p>
        </div>
      </div>
    </div>


  );
};



// Mail.propTypes = {
//   message: PropTypes.shape({
//     img: PropTypes.string.isRequired,
//     type: PropTypes.string.isRequired,
//     email: PropTypes.string.isRequired,
//     date: PropTypes.string.isRequired,
//     time: PropTypes.string.isRequired,
//     subject: PropTypes.string.isRequired,
//     salutation: PropTypes.string.isRequired,
//     conclusion: PropTypes.string.isRequired,
//     sender: PropTypes.string.isRequired,
//     closing: PropTypes.string.isRequired,
//     message: PropTypes.string.isRequired,
//     attached: PropTypes.bool.isRequired
//   }),
//   index: PropTypes.number
// };

const Conversation = ({ ticketMasterId }) => {
  const [showReplyForm, setShowReplyForm] = useState(false);
  const [profilePicture, setProfilePicture] = useState(null);

  const [isFeedbackSubmittedd, setIsFeedbackSubmittedd] = useState(false);
  const [isTicketClosedd, setIsTicketClosedd] = useState(false);

  const userDataRaw = localStorage.getItem('userData');
  const _userData = userDataRaw ? JSON.parse(userDataRaw) : {};

  const _gmtOffset = "+5:31";

  const [ticketMaster, setTicketMaster] = useState(
    {
      ticketNumber: null,
      contactTypeId: null,
      subject: null,
      priorityId: null,
      ticketStatusId: null,
      dueDate: null,
      created: null,
      userId: null,
      updatedDateTime: null,
      userLogId: null,
      assetsMasterId: null,
      assetCategoryId: null,
      uMT: null,
      gmt_Offset: null,
      client: null,
      ticketChargingTypeName: null,
      agent: null,
      priorityName: null,
      categoryName: null,
      assetsName: null,
      assetNumber: null,
      time_elapsed: null,
      companyMasterId: null,
    }
  );

  const [loadIsAccepted, setLoadIsAccepted] = useState(false);
  const [isAccepted, setIsAccepted] = useState(false);
  const [isTicketRejected, setIsTicketRejected] = useState(false);
  const [loadTicketRejectStatus, setLoadTicketRejectStatus] = useState(false);

  const [loadlastConversation, setLoadlastConversation] = useState(0);
  const [deleteConversation, setDeleteConversation] = useState(0);
  const [deletedMessageId, setDeletedMessageId] = useState(0);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [rejectReason, setRejectReason] = useState('');

  useEffect(() => {
    socket.off("receive_action"); // Remove existing event listener
    socket.on("receive_action", data => {

      console.log('receive_action triggerd conversation', data);
      if (data.action === "replyConversation") {

        if (_userData.roleId === 3)
          playNotificationAgentConversation();
        else
          playNotificationSoundConversation();

        setLoadlastConversation(prev => prev + 1);
      }

      if (data.action === "deleteConversation") {
        setDeletedMessageId(data.messageId);
        setDeleteConversation(prev => prev + 1);
      }




    });
  }, []);

  useEffect(() => {
    refresRemoveDeleteReply(deletedMessageId);
  }, [deleteConversation]);


  useEffect(() => {
    refrehConversations();
  }, [loadlastConversation]);



  const refresRemoveDeleteReply = (ticketDetailId) => {
    const updatedMessages = messages.map(message => {
      if (message.ticketDetailId === ticketDetailId) {
        // If the ticketDetailId matches, update isDeleted to true
        return {
          ...message,
          isDeleted: true
        };
      }
      return message; // For other messages, return as is
    });
    setMessages(updatedMessages);
  };


  const removeDeleteReplyHandler = async ticketDetailId => {
    refresRemoveDeleteReply(ticketDetailId);
    socket.emit("send_action", { action: 'deleteConversation', messageId: ticketDetailId, room: ticketMasterId })
  };



  const sendMessage = () => {
    socket.emit("send_action", { action: 'replyConversation', room: ticketMasterId });
    socket.emit("send_action", { action: 'refreshNotification', room: 'notification' })
  }


  useEffect(() => {
    joinRoom(ticketMasterId);
  }, []);

  const joinRoom = (room) => {
    console.log('joinRoom triggerd')
    if (room !== "") {
      socket.emit('join_room', room)
    }

  }

  useEffect(() => {
    loadIsTicketClosed();
    loadTicketRejectStatusHandler();
  }, []);

  useEffect(() => {
    loadIsTicketAccepted();
  }, [loadIsAccepted])

  useEffect(() => {
    loadTicketRejectStatusHandler();
  }, [loadTicketRejectStatus])

  useEffect(() => {
    setMarkAsSeen();

  }, [])

  const loadTicketRejectStatusHandler = async () => {
    const token = localStorage.getItem('token');
    try {
      const result = await getTicketRejectStatus(ticketMasterId, token);
      console.log('Ticket reject status result:', result);

      // Check if we have recordset with data
      if (result && result.recordset && Array.isArray(result.recordset) && result.recordset.length > 0) {
        // Find if any record has IsReject: true for this ticket
        const rejectedTicket = result.recordset.find(ticket => ticket.IsReject === false);
        setIsTicketRejected(!!rejectedTicket);
        console.log('Is ticket rejected:', !!rejectedTicket);
      } else {
        // No records found, ticket is not rejected
        setIsTicketRejected(false);
        console.log('No records found, ticket is not rejected');
      }
    } catch (error) {
      console.error('Error loading ticket reject status:', error);
      setIsTicketRejected(false);
    }
  };

  const setMarkAsSeen = async () => {
    const token = localStorage.getItem('token');
    await markConversationAsSeen({ messageId: ticketMasterId }, token);

  }



  // 
  const loadIsTicketAccepted = async () => {
    try {

      const token = localStorage.getItem('token');

      const obj = await isTicketAccepted(ticketMasterId, token);
      setIsAccepted(obj.IsAccepted);


    } catch (err) {
      console.log('Error:', err);
    }
  };

  const loadIsFeedbackSubmitted = async () => {
    try {

      const token = localStorage.getItem('token');
      const obj = await isFeedbackSubmitted(ticketMasterId, token);
      console.log('loadIsFeedbackSubmitted :', obj);
      if (obj && obj.output) {
        const { IsSubmitted } = obj.output;
        setIsFeedbackSubmittedd(IsSubmitted);
      }

    } catch (err) {
      console.log('Error:', err);
    }
  };

  const loadIsTicketClosed = async () => {
    try {

      const token = localStorage.getItem('token');
      const obj = await isTicketClosed(ticketMasterId, token);
      if (obj && obj.output) {
        const { IsClosed } = obj.output;
        setIsTicketClosedd(IsClosed);
      }

    } catch (err) {
      console.log('Error:', err);
    }
  };



  const [messages, setMessages] = useState([])

  useEffect(() => {
    loadAll();
  }, [ticketMasterId]);


  const loadTicketMasterDetailsGreaterThanTicketDetailId = async (ticketDetailId) => {
    try {
      const token = localStorage.getItem('token');
      const obj = await getTicketMasterDetailsGreaterThanTicketDetailId(ticketDetailId, token);
      return obj;

    } catch (err) {
      console.log('Error:', err);
    }
  };


  const getMaxClientSideDetailId = async () => {

    return new Promise((resolve, reject) => {

      let maxDetailId = 0;
      let curDetailId = 0;
      let loopCount = 0;
      if (!messages || messages.length === 0) {
        resolve(0);
        return;
      }
      for (let i = 0; i < messages.length; i++) {
        curDetailId = messages[i].ticketDetailId;

        if (maxDetailId < curDetailId) {
          maxDetailId = curDetailId;
        }
        loopCount++;
        if (loopCount === messages.length) {
          resolve(maxDetailId);
        }
      }
    })

    //return 10;
  }


  const getMaxDetailIdFromBackend = async () => {
    const token = localStorage.getItem('token');
    const maxDetailsId = await checkForNewReply(ticketMasterId, token);
    return maxDetailsId.MaxTicketDetailId;
  }

  const updateToCkentSideDetails = async (lastMessages) => {

    if (!lastMessages || !Array.isArray(lastMessages)) return;

    const existingTicketDetailIds = messages.map(m => m.ticketDetailId);

    const filteredMessages = lastMessages.filter(msg => msg && !existingTicketDetailIds.includes(msg.ticketDetailId));

    const messageArr = [];
    filteredMessages.filter(td => td).map(td => {
      let profileImg = `${API}/file/image/${td.ProfilePic}`;
      if (td.ProfilePic === null) {
        profileImg = avatarImg;
      }

      const messageObj = {
        ticketDetailId: td.TicketDetailId,
        img: profileImg,
        type: `via ${td.ContactType}`,
        email: td.Email,
        createdDate: moment(td.CreatedDate_UTC).format('DD MMM, yyyy hh:mm A'),
        //date: moment(createdDateWithOffset).format('DD MMM, yyyy'),

        //  time: `${(td.CreatedDateTime.split("T")).replace("Z","")} (${
        //    td.time_elapsed
        //  })`, // '8:40 AM (1 Day ago)',
        time_elapsed: timeElapsed(td.CreatedDate_UTC),
        // time: td.CreatedDateTime.split("T").replace("Z",""),

        subject: td.Subject,
        salutation: '',
        message: td.Description,
        conclusion: '',
        closing: '',
        sender: td.ContactPerson,
        attached: true,
        isPrivateMessage: td.IsPrivateMessage,
        isDeleted: td.IsDeleted,
        userId: td.UserID,
        isAttachmentExists: td.isAttachmentExists
      };

      messageArr.push(messageObj);
    });

    setMessages(msgs => [...messageArr, ...msgs]);
  }


  const refrehConversations = async () => {
    const maxClientSideDetailId = await getMaxClientSideDetailId();
    //const maxDetailIdfromBackend = await getMaxDetailIdFromBackend();

    await loadIsTicketAccepted();

    const latestDetails = await loadTicketMasterDetailsGreaterThanTicketDetailId(maxClientSideDetailId);
    console.log('latestDetail--', latestDetails);
    updateToCkentSideDetails(latestDetails);


    await loadIsFeedbackSubmitted();
    await loadIsTicketClosed();
  };

  const loadAll = async () => {
    console.log('loadAll');
    await loadTicketMasterHeader(ticketMasterId);
    await loadTicketDetails(ticketMasterId);


  }


  const [companyId, setCompanyId] = useState(null);

  const loadTicketMasterHeader = async (ticketMasterId) => {
    const token = localStorage.getItem('token');
    const obj = await getTicketMasterCon(ticketMasterId, token);
    console.log('loadTicketMasterHeader', obj);
    if (!obj) {
      console.error('Failed to load ticket master header');
      return;
    }
    console.log('ticketMaster', ticketMaster);
    setCompanyId(obj.CompanyMasterId);
    console.log('companyId', companyId);
    setTicketMaster({
      ticketNumber: obj.TicketNumber,
      contactTypeId: obj.ContactTypeId,
      subject: obj.Subject,
      priorityId: obj.PriorityId,
      ticketStatusId: obj.TicketStatusId,
      dueDate: obj.DueDate,
      userId: obj.UserID,
      userLogId: obj.UserLogID,
      assetsMasterId: obj.AssetsMasterId,
      assetCategoryId: obj.AssetCategoryId,
      createdDate: obj.CreatedDate_UTC,
      gmt_Offset: obj.GMT_Offset,
      client: obj.Client,
      ticketChargingTypeName: obj.TicketChargingTypeName,
      agent: obj.Agent,
      priorityName: obj.PriorityName,
      categoryName: obj.CategoryName,
      assetsName: obj.AssetsName,
      assetNumber: obj.AssetNumber,
      time_elapsed: timeElapsed(obj.CreatedDate_UTC),
      contactType: obj.ContactType,
      companyMasterId: obj.CompanyMasterId,
    });
  }





  const loadTicketDetails = async ticketMasterId => {

    try {
      const token = localStorage.getItem('token');

      const obj = await getTicketMasterDetails(ticketMasterId, false, token);
      const messagesArr = [];
      if (obj && Array.isArray(obj)) {
        obj.filter(td => td).map(td => {

          let profileImg = `${API}/file/image/${td.ProfilePic}`;
          if (td.ProfilePic === null) {
            profileImg = avatarImg;
          }


          messagesArr.push({
            ticketDetailId: td.TicketDetailId,
            img: profileImg,
            type: `via ${td.ContactType}`,
            email: td.Email,
            createdDate: moment(td.CreatedDate_UTC).format('DD MMM, yyyy hh:mm A'),
            time_elapsed: timeElapsed(td.CreatedDate_UTC),

            subject: td.Subject,
            salutation: '',
            message: td.Description,
            conclusion: '',
            closing: '',
            sender: td.ContactPerson,
            attached: true,
            isPrivateMessage: td.IsPrivateMessage,
            isDeleted: td.IsDeleted,
            userId: td.UserID,
            isAttachmentExists: td.isAttachmentExists
          });
        });
      }

      setMessages(messagesArr);

    } catch (err) {
      console.log('Error:', err);
    }
  };





  const { subject, contactTypeId, ticketNumber, priorityId, ticketStatusId, dueDate,
    created, userId, updatedDateTime, userLogId, assetsMasterId, assetCategoryId,
    uMT, gmt_Offset, client, ticketChargingTypeName, agent, priorityName, categoryName,
    assetsName, assetNumber, time_elapsed } = ticketMaster;



  const addAttributesToImgTags = (htmlString) => {
    const imgTagRegex = /<img[^>]+>/g;

    const updatedString = htmlString.replace(imgTagRegex, (imgTag) => {
      if (
        !imgTag.includes('alt=') &&
        !imgTag.includes('style=')
      ) {
        // If alt and style attributes don't exist, add them
        const updatedTag = imgTag.replace(
          '>',
          ` id='reply-imagethumb' alt='Image' style='width:90%; object-fit:scale-down; object-position:left;cursor:pointer' >`
        );

        // Wrap the updatedTag with a label element
        // const wrappedTag = `<label for="modal-trigger">${updatedTag}</label>`;
        //  return wrappedTag;
        return updatedTag;
      }
      return imgTag;
    });

    return updatedString;
  };





  const handleSubmitReply = async (obj) => {
    const token = localStorage.getItem('token');

    const { description, attachments, isPrivateMessage, usersForPrivateMessge, selectedUser } = obj;

    console.log('handleSubmitReply received:', obj); // Debug log

    if (!description || description.length === 0) {
      toastMessageBox("Required Field", "Enter description", "danger");
      return;
    }

    if (!ticketMasterId) {
      toastMessageBox("Error", "Ticket ID is missing", "danger");
      console.error('ticketMasterId is undefined');
      return;
    }

    // Validate user selection when not private messag

    const fileUploadObjs = [];

    Array.from(attachments).forEach(attachment => {
      fileUploadObjs.push({
        fileNo: attachment.fileNo,
        size: attachment.size,
        type: attachment.type,
        name: attachment.name
      });
    });

    const data = {
      ticketMasterId: ticketMasterId,
      description: addAttributesToImgTags(description),
      gmtOffset: _gmtOffset,
      fileUploadObjs: fileUploadObjs,
      isPrivateMessage: isPrivateMessage || false,
      privateMessageUserObjs: usersForPrivateMessge || [],
      recipientEmail: !isPrivateMessage ? selectedUser : null
    };

    console.log('Submitting reply with data:', data);

    const res = await addTicketDetail(data, token);

    if (!res || !res.data) {
      toastMessageBox("Error", "Invalid response from server", "danger");
      return;
    }

    if (res.data.error) {
      toastMessageBox("error", res.data.error, "danger");
      return;
    }

    if (!res.data.output) {
      toastMessageBox("Error", "Invalid response structure", "danger");
      console.error('Response data:', res.data);
      return;
    }

    const { TicketDetailId_o, outputMessage, responseStatus } = res.data.output;

    if (responseStatus === "success") {
      refrehConversations();
      sendMessage();
      clearReply();

      if (isPrivateMessage) {
        toastMessageBox("Success", "Private message sent to selected users", "success");
      } else {
        toastMessageBox("Success", `Message sent to ${selectedUser}`, "success");
      }
    } else {
      toastMessageBox("Error", outputMessage || "Failed to add reply", "danger");
    }
  };



  const rejectTicketHandler = async () => {
    console.log('rejectTicketHandler called');
    const userData = JSON.parse(localStorage.getItem('userData'));
    const token = localStorage.getItem('token');
    const {
      subject,
      client, // recipientName
      createdDate, // submittedDate
      gmt_Offset, // utcOffset
      companyMasterId, // companyName (you may need to fetch the name if you only have the ID)
      ticketNumber, // ticketNo
      userId, // recipient userId
      ticketNumber: ticketId, // or use ticketMasterId if that's the backend key
    } = ticketMaster;
    console.log('client:', client);

    // Fetch user data and find the matching client
    let recipientEmail = '';
    try {
      const addeduser = await getUsers(token, "");
      console.log('addeduser', addeduser);

      console.log('ticketMaster', ticketMaster);
      console.log('client:', ticketMaster.client);

      if (addeduser && Array.isArray(addeduser)) {
        const match = addeduser.find(user => user.UserName === ticketMaster.client);
        console.log('match', match ? match.Email : 'No matching user found');

        if (match && match.Email) {
          recipientEmail = match.Email;
        }
      } else {
        console.error('Failed to fetch users or received invalid data', addeduser);
      }
    } catch (error) {
      console.error('Error fetching user data:', error);
    }

    // If you have description elsewhere, fetch it accordingly
    const description = "Rejection"; // adjust as needed

    try {
      const token = localStorage.getItem('token');
      const res = await ticketReject(
        {
          ticketMasterId,
          userId: userData.userId,
          rejectReason,
          recipientEmail,
          subject,
          recipientName: client,
          submittedDate: createdDate,
          utcOffset: gmt_Offset,
          companyName: companyMasterId, // replace with actual name if needed
          ticketNo: ticketNumber,
          description,
          ticketId: ticketMasterId
        },
        token
      );

      if (!res || !res.output) {
        toastMessageBox("Error", "No response from server.", "error");
        return;
      }
      if (res.output.responseStatus === "failed") {
        toastMessageBox("Failed", res.output.outputMessage, "error");
        return;
      }

      // Success path
      toastMessageBox("Successful", res.output.outputMessage, "success");
      setShowRejectModal(false);
      setRejectReason("");

      // Refresh the ticket data after rejection
      await refrehConversations();
      setLoadTicketRejectStatus(!loadTicketRejectStatus);

      // Reload the page to reflect the new status
      setTimeout(() => {
        window.location.reload();
      }, 1000); // Small delay to allow the toast message to be seen
    } catch (err) {
      toastMessageBox("Error", err?.message || "Unknown error", "error");
      console.log('Error', err);
    }
  };


  const acceptTicketHandler = () => {

    const data = {
      ticketMasterId: ticketMasterId,
      accept: true
    };
    const token = localStorage.getItem('token');
    acceptTicket(data, token)
      .then(async res => {
        const { outputMessage, responseStatus } = res.output;
        if (responseStatus === "failed") {
          toastMessageBox("Exception", outputMessage, "warning");
          return;
        }

        setLoadIsAccepted(!loadIsAccepted);
        setLoadTicketRejectStatus(!loadTicketRejectStatus);

        await refrehConversations();
        toastMessageBox("Successful", "Accepted successfully.", "success");

        // Small delay to allow the toast message to be seen
        setTimeout(() => {
          window.location.reload();
        }, 1000);

      })
      .catch(err => {
        console.log('Error: ', err);
      });
  };


  const openTicketHandler = () => {

    const data = {
      ticketMasterId: ticketMasterId,
      accept: true
    };
    const token = localStorage.getItem('token');
    openTicket(data, token)
      .then(async res => {
        console.log('openTicketHandler: ', res.data);
        const { outputMessage, responseStatus } = res.data.output;
        if (responseStatus === "failed") {
          toastMessageBox("Exception", outputMessage, "warning");
          return;
        }

        setIsTicketClosedd(false);

        //await refrehConversations();
        toastMessageBox("Successful", "Opend successfully.", "success");

      })
      .catch(err => {
        console.log('Error: ', err);
      });
  };


  const [clearReplyFields, setClearReplyFields] = useState(false);
  const clearReply = () => {
    setClearReplyFields(true);
    setClearReplyFields(true);
    setShowReplyForm(false);
  };


  const onsubmitLoadHandler = () => {
    console.log('onsubmitLoadHandler ******* :');
    loadIsFeedbackSubmitted();
  }

  useEffect(() => {
    const refreshMethod = async () => {
      // Replace this with the method you want to refresh
      await refrehConversations();
      console.log('Refreshing method...');
    };

    // const interval = setInterval(refreshMethod, 10000); // Refresh every 10 seconds

    // return () => {
    //   clearInterval(interval); // Clean up the interval when the component unmounts
    // };
  }, []);

  const replyComp = () => {

    return <>
      {/* <BrowserNotification message={{subject:'message',body:'meee'}} /> */}
      {/* <button onClick={()=>{
     
     socket.emit("send_action",{action:'replyConversation',room:ticketMasterId});

  }}>test socket</button>

<button onClick={()=>{
     
     joinRoom(ticketMasterId);

  }}>joinRoom</button> */}


      {showReplyForm && (
        <Reply
          setShowReplyForm={setShowReplyForm}
          onSubmitReply={handleSubmitReply}
          title="Reply"
          bodyClassName="shadow-none"
          clearReplyFields={clearReplyFields}
        />
      )}
      {!showReplyForm && (
        <Card.Footer className="bg-light">
          <IconButton
            size="sm"
            variant="falcon-default"
            icon="reply"
            onClick={() => setShowReplyForm(true)}
          >
            <span className="d-none d-sm-inline-block ms-1">Reply</span>
          </IconButton>

        </Card.Footer>
      )}

    </>
  }



  const ConversationComp = () => {

    const onRejectClick = () => {
      setShowRejectModal(true); // Open modal
    };

    return (
      <Card className="mt-3">
        {!ticketMaster ? (
          <p>loading...</p>
        ) : (
          <Card.Header className="bg-light">
            <h5 className="mb-0">
              <FontAwesomeIcon icon="envelope" className="me-2" />
              {subject}
            </h5>
            {isTicketRejected && (
              <div className="mt-2">
                <span className="badge bg-danger">
                  <FontAwesomeIcon icon="times-circle" className="me-1" />
                  This ticket has been rejected
                </span>
              </div>
            )}
            {/* <IconButton
          size="sm"
          variant="falcon-default"
          icon="reply"
          onClick={()=>{
            sendMessage();
          }}
        >
          <span className="d-none d-sm-inline-block ms-1">sendMessage</span>
        </IconButton> */}
            {/* <IconButton
          size="sm"
          variant="falcon-default"
          icon="reply"
          onClick={()=>{
            refrehConversations();
          }}
        >
          <span className="d-none d-sm-inline-block ms-1">refrehConversations</span>
        </IconButton> */}
          </Card.Header>
        )}


        {!isTicketClosedd && isAccepted && replyComp()}

        {isTicketClosedd && (
          <>
            <IconButton
              size="sm"
              variant="falcon-default"
              icon="reply"
              onClick={openTicketHandler}
            >
              <span className="d-none d-sm-inline-block ms-1">Reopen Ticket</span>
            </IconButton>
          </>
        )}

        {!isTicketClosedd && !isAccepted && (
          <div style={{
            display: 'flex',
            gap: '8px',
            alignItems: 'center',
            marginBottom: '5px',
            justifyContent: 'flex-end', // Aligns content to the right
            marginRight: '15px', // Adds some margin from the right edge
            marginTop: '5px' // Adds some space from the top
          }}>
            <IconButton
              size="xs" // Changed from sm to xs for smaller buttons
              variant="success"
              icon="reply"
              onClick={acceptTicketHandler}
              disabled={isTicketRejected}
              style={{
                padding: '3px 8px',
                fontSize: '0.85rem',
                opacity: isTicketRejected ? 0.5 : 1,
                cursor: isTicketRejected ? 'not-allowed' : 'pointer'
              }}
            >
              <span className="d-none d-sm-inline-block ms-1">Accept</span>
            </IconButton>
            <IconButton
              size="xs" // Changed from sm to xs for smaller buttons
              variant="danger"
              icon="times"
              onClick={onRejectClick}
              disabled={isTicketRejected}
              style={{
                padding: '3px 8px',
                fontSize: '0.85rem',
                opacity: isTicketRejected ? 0.5 : 1,
                cursor: isTicketRejected ? 'not-allowed' : 'pointer'
              }}
            >
              <span className="d-none d-sm-inline-block ms-1">Reject</span>
            </IconButton>
          </div>
        )}


        {/* {JSON.stringify(messages)} */}
        {messages.map((message, index) => {

          if (message.isDeleted) {
            return <DeletedMessage key={index} message={message} />;
          } else {
            return (
              <React.Fragment key={index}>
                {message.isPrivateMessage ? (
                  <MessagePrivate
                    key={index}
                    message={message}
                    index={index}
                    onRemoveDeleteReply={removeDeleteReplyHandler}
                  />
                ) : (
                  <MessagePublic
                    key={index}
                    message={message}
                    index={index}
                    onRemoveDeleteReply={removeDeleteReplyHandler}
                  />
                )}
              </React.Fragment>
            );
          }
        })}



      </Card>
    );
  }



  return (
    <>
      {/* <WebSocketClient /> */}
      {/* {'isFeedbackSubmittedd : ' + JSON.stringify(isFeedbackSubmittedd)}
      <br />
      {'isTicketClosedd : ' + JSON.stringify(isTicketClosedd)}
      <br />
      {'IsAccepted : ' + JSON.stringify(isAccepted)} */}

      {/* {_userData.roleId==1 && <TicketsPreviewHeader  ticketMasterId={ticketMasterId} />}
      {_userData.roleId==5 && <TicketsPreviewHeader  ticketMasterId={ticketMasterId} />}
      {_userData.roleId==4 && <TicketsPreviewHeader  ticketMasterId={ticketMasterId} />}
      {_userData.roleId==3 && <TicketsPreviewHeader  ticketMasterId={ticketMasterId} />} */}

      {/* {_userData.roleId === 1 && <ConversationComp />}
      {_userData.roleId === 5 && <ConversationComp />}
      {_userData.roleId === 4 && <ConversationComp />}
      {_userData.roleId === 3 && <ConversationComp />}
      {_userData.roleId === 2 && <ConversationComp />} */}

      {showRejectModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          background: 'rgba(0,0,0,0.5)',
          zIndex: 9999,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
          <div style={{
            background: 'linear-gradient(135deg,rgb(187, 181, 180) 0%,rgb(87, 82, 81) 100%)',
            color: '#fff',
            padding: '2rem',
            borderRadius: '18px',
            boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.37)',
            width: '400px',
            maxWidth: '90vw',
            position: 'relative',
            border: '2px solid #fff',
            animation: 'popIn 0.3s cubic-bezier(.68,-0.55,.27,1.55)'
          }}>
            <h2 style={{
              fontSize: '1.5rem',
              fontWeight: 700,
              marginBottom: '1.2rem',
              textAlign: 'center',
              letterSpacing: '1px',
              color: '#fff',
              textShadow: '0 2px 8pxrgb(39, 231, 65)'
            }}>Reject Ticket</h2>
            <textarea
              style={{
                width: '100%',
                border: '1.5px solid #fff',
                borderRadius: '8px',
                padding: '0.75rem',
                marginBottom: '1.2rem',
                color: '#e73827',
                fontWeight: 600,
                fontSize: '1rem',
                background: '#fff',
                minHeight: '80px',
                outline: 'none',
                boxShadow: '0 2px 8pxrgb(90, 248, 50)',
                transition: 'border 0.2s',
              }}
              rows="4"
              placeholder="Enter rejection reason..."
              value={rejectReason}
              onChange={(e) => setRejectReason(e.target.value)}
            ></textarea>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.7rem' }}>
              <button
                onClick={() => setShowRejectModal(false)}
                style={{
                  background: 'linear-gradient(135deg, #43cea2 0%, #185a9d 100%)',
                  color: '#fff',
                  padding: '0.6rem 1.4rem',
                  border: 'none',
                  borderRadius: '8px',
                  fontWeight: 600,
                  fontSize: '1rem',
                  cursor: 'pointer',
                  boxShadow: '0 2px 8px #185a9d',
                  transition: 'background 0.2s',
                }}
              >
                Cancel
              </button>
              <button
                onClick={rejectTicketHandler}
                style={{
                  background: 'linear-gradient(135deg,rgb(247, 64, 58) 0%,rgb(248, 208, 28) 100%)',
                  color: '#e73827',
                  padding: '0.6rem 1.4rem',
                  border: 'none',
                  borderRadius: '8px',
                  fontWeight: 700,
                  fontSize: '1rem',
                  cursor: 'pointer',
                  boxShadow: '0 2px 8px #f85032',
                  transition: 'background 0.2s',
                }}
              >
                Confirm Reject
              </button>
            </div>
          </div>
          <style>{`
      @keyframes popIn {
        0% { transform: scale(0.7); opacity: 0; }
        100% { transform: scale(1); opacity: 1; }
      }
    `}</style>
        </div>
      )}


      <TicketsPreviewHeader ticketMasterId={ticketMasterId}
        companyMasterId={ticketMaster?.companyMasterId} 
        isAccepted={isAccepted}
        assignedAgent={ticketMaster?.agent}
        currentUserName={_userData?.userName} />

      <TicketWorkTimer
        ticketMasterId={ticketMasterId}
        authToken={localStorage.getItem('token')}
      />

      <TicketManualTimeEntry
        ticketMasterId={ticketMasterId}
        authToken={localStorage.getItem('token')}
        userId={_userData?.userId}
      />

      <ConversationComp />



      {_userData.roleId === 2 && isTicketClosedd && !isFeedbackSubmittedd && (
        <CustomerReview ticketMasterId={ticketMasterId} onsubmitLoad={onsubmitLoadHandler} />
      )}

      {/* <CustomerFeedbackView rating={10} totalReview={10}/> */}
    </>
  );
};

export default Conversation;
